import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsFirstAuthAttempt = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.isFirstAuthAttempt);
};
